import {doPost} from './http.service'

export interface FileInfo {
    id?:string,
    mimeType?:string
    contentLength?:number
    directory?:string
    originalName?:string
    createdAt?: number
    modifiedAt?:number
    cacheControl?:number
    content?: string,
}

export function uploadFile(payload: FileInfo) {
    return doPost<FileInfo>('/public/files', payload);
}
